var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-name-hint"},[_vm._v(" Поиск по УНП происходит только по полному соответствию, внимательно проверяйте вводимое значение. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }